export default function isUndefined(subject) {
  return typeof subject === 'undefined';
}